export function savReducer(state = {
    WAITING : {},
    IN_REPAIR : {},
    REPAIRED : {},
    BACK_IN_STOCK : {},
    HS : {},
    ALL: {}
},{
    type,
    payload
}){
    
    switch(type){
        case "ADD_SAV":
            return {
                ...state,
                ALL: { ...state.ALL, [payload.id]: payload },
                [payload.sav_last_status]: { ...state[payload.sav_last_status], [payload.id]: payload },
            }
        case "UPDATE_SAV":
            const { oldStatus, sav } = payload;
            const oldStatusCopy = { ...state[oldStatus] };
            delete oldStatusCopy[sav.id]; // delete from old status copy

            // If old and new status are the same, work off the same copy
            if (oldStatus === sav.sav_last_status) {
                return {
                    ...state,
                    ALL: { ...state.ALL, [sav.id]: sav },
                    [oldStatus]: { ...oldStatusCopy, [sav.id]: sav },
                }
            }

            return {
                ...state,
                ALL: { ...state.ALL, [sav.id]: sav },
                [oldStatus]: oldStatusCopy,
                [sav.sav_last_status]: { ...state[sav.sav_last_status], [sav.id]: sav },
            }

        case "GET_SAVS":
            return payload
        default:
            return state;
    }
    
}